export default __webpack_public_path__ + "static/media/close-pop.a7eb4f3f.svg";